
import React from "react"
import { IIconProps } from "./Icon/Interfaces"

const ArrowDownRoundedIcon = ({
	width = 13,
	height = 10,
  strokeColor='var(--blue)',
}: IIconProps) => {
	return (
    <svg viewBox="0 0 13 10" width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.26 8.79a1 1 0 0 1-1.585 0L.778 2.43A1 1 0 0 1 1.571.82h9.793a1 1 0 0 1 .792 1.61L7.26 8.79Z" fill={strokeColor} />
    </svg>
	)
}

export default ArrowDownRoundedIcon
